import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import React, { useState, Fragment } from 'react'
import Tooltip from '@mui/material/Tooltip';
const data = [
    { id: 1, marca: 'marca 1', contenidoalcoholico: '35%', numeroanalisis: '123ASD456', numerocertificado: '789FGH123', numerolote: '12' },
    // { id: 2, marca: 'marca 2', contenidoalcoholico: '55%', numeroanalisis: 'SFG544545', numerocertificado: 'FGFGHFGH5', numerolote: '5' },
    // { id: 3, marca: 'marca 3', contenidoalcoholico: '45%', numeroanalisis: 'FHFGHHFG5', numerocertificado: '5FGHFGHF5', numerolote: '6' },
    // { id: 4, marca: 'marca 4', contenidoalcoholico: '35%', numeroanalisis: 'FGHKHJG66', numerocertificado: '674GHFGHF', numerolote: '23' }
];

class Productos extends React.Component {
    state = {
        data: data,
        Actualizar: false,
        Insertar: false,
        form: {
            id: "",
            contenidoalcoholico: "",
            numeroanalisis: "",
            numerocertificado: "",
            marca: "",
            numerolote: "",
            contenidonetobotella: "",
            unidad: "",
            numerobotellas: "",
            numerocajas: "",
        },
    };

    mostrarModalActualizar = (dato) => {
        this.setState({
            form: dato,
            Actualizar: true,
        });
    };

    cerrarModalActualizar = () => {
        this.setState({ Actualizar: false });
    };

    mostrarModalInsertar = () => {
        this.setState({
            modalInsertar: true,
        });
    };

    cerrarModalInsertar = () => {
        this.setState({ modalInsertar: false });
    };

    editar = (dato) => {
        var contador = 0;
        var arreglo = this.state.data;
        arreglo.map((registro) => {
            if (dato.id == registro.id) {
                arreglo[contador].personaje = dato.personaje;
                arreglo[contador].anime = dato.anime;
            }
            contador++;
        });
        this.setState({ data: arreglo, modalActualizar: false ,
            form: {
                id: "",
                contenidoalcoholico: "",
                numeroanalisis: "",
                numerocertificado: "",
                marca: "",
                numerolote: "",
                contenidonetobotella: "",
                unidad: "",
                numerobotellas: "",
                numerocajas: "",
            }});
    };

    eliminar = (dato) => {
        var opcion = window.confirm("Estás Seguro que deseas Eliminar el elemento " + dato.id);
        if (opcion == true) {
            var contador = 0;
            var arreglo = this.state.data;
            arreglo.map((registro) => {
                if (dato.id == registro.id) {
                    arreglo.splice(contador, 1);
                }
                contador++;
            });
            this.setState({ data: arreglo, modalActualizar: false });
        }
    };

    insertar = () => {
        var valorNuevo = { ...this.state.form };
        valorNuevo.id = this.state.data.length + 1;
        var lista = this.state.data;
        lista.push(valorNuevo);
        this.setState({ modalInsertar: false, data: lista, 
            form: {
            id: "",
            contenidoalcoholico: "",
            numeroanalisis: "",
            numerocertificado: "",
            marca: "",
            numerolote: "",
            contenidonetobotella: "",
            unidad: "",
            numerobotellas: "",
            numerocajas: "",
        }});
    }

    handleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            },
        });
    };
    valueChange = (e) => {
        this.setState({
            form: {
                [e.target.name]: '',
            },
        });
    };

    render() {

        return (
            <>

                <FormGroup>
                    <div className='row align-items-center'>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="number" min='0' className={`form-control `} id="floatingInput" placeholder='Contenido Alcohólico'
                                    name="contenidoalcoholico" onChange={this.handleChange} value={this.state.form.contenidoalcoholico}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                
                                <Tooltip title={`Contenido Alcohólico`} arrow>
                                    <label htmlFor='floatingInput'>% Alc. Vol.</label>
                                </Tooltip>

                                {this.state.form.contenidoalcoholico < 36 || this.state.form.contenidoalcoholico > 55 ?
                                (<span className='text-danger'>El rango debe de ser de 36% a 55%</span>):''
                                }
                                {/* {contenidoalcoholico < 36 || contenidoalcoholico > 55 ?
                                <span className='text-danger'>el rango debe de ser de 36% a 55%</span> : ''
                            } */}
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" min='0' className={`form-control `} id="floatingInput" placeholder='No. de análisis de laboratorio'
                                    name="numeroanalisis" onChange={this.handleChange} value={this.state.form.numeroanalisis}/>
                                <label htmlFor='floatingInput'>No. de análisis de laboratorio</label>
                                <br />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" placeholder='No. de certificado NOM'
                                    name="numerocertificado" onChange={this.handleChange} value={this.state.form.numerocertificado}
                                />
                                <label htmlFor='floatingInput'>No. de certificado NOM vigente</label>
                                <br />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">

                                <select onChange={this.handleChange}
                                    name="marca" value={this.state.form.marca}
                                    className={`form-select form-select-sm `}
                                >
                                    <option value="0" disabled>Marca</option>
                                    <option value="Marca 1">Marca 1</option>
                                    <option value="Marca 2">marca 2</option>
                                    <option value="marca 3">marca 3</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <br />
                            <div className="form-floating mb-3">
                                <input type="text" className={`form-control `} id="floatingInput" placeholder='No. de lote envasado'
                                    name="numerolote" onChange={this.handleChange} value={this.state.form.numerolote}
                                />
                                <label htmlFor='floatingInput'>No. de lote envasado:</label>
                                <br />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <br />
                            <div className="form-floating mb-3">
                                <input type="number" min='0' className={`form-control `} id="floatingInput" placeholder='Contenido neto x botella'
                                    name="contenidonetobotella" onChange={this.handleChange} value={this.state.form.contenidonetobotella}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>Contenido neto x botella</label>
                                {/* {this.state.form.contenidonetobotella < 36 || this.state.form.contenidonetobotella > 55 ?
                                (<span className='text-danger'>El rango debe de ser de 36% a 55%</span>):''
                                } */}
                                <br />
                            </div>
                        </div>
                        <div className='col-md-1'>
                            <div className="form-floating mb-3">

                                <select onChange={this.handleChange}
                                    name="unidad"
                                    className={`form-select form-select-sm `}
                                >
                                    <option value="0" disabled>Tipo</option>
                                    <option value="ml">ml</option>
                                    <option value="L">L</option>
                                    <option value="cl">cl</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="number" min='0' className={`form-control `} id="floatingInput" placeholder='No. de batellas'
                                    name="numerobotellas" onChange={this.handleChange} value={this.state.form.numerobotellas}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>No. de botellas</label>
                                <br />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="number" min='0' className={`form-control `} id="floatingInput" placeholder='No. de cajas'
                                    name="numerocajas" onChange={this.handleChange} value={this.state.form.numerocajas}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>No. de cajas</label>
                                <br />
                            </div>
                        </div>
                    </div>
                </FormGroup>
                {this.state.Actualizar ?(<div className="text-center">
                    <button className='botonAgregarAnexo col-md-3' onClick={() => this.editar(this.state.form)}>Editar</button>
                    <button className='botonCancelar col-md-3' onClick={() => this.cerrarModalActualizar()}>Cancelar</button>
                    
                </div>):(
                <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                    <button className='botonAgregarAnexo col-md-3' onClick={() => this.insertar()}>Agregar</button>
                </div>)}
                <Container>
                    <br />
                    <br />
                    <br />
                    <Table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Contenido Acoholico</th>
                                <th>Numero de analisis</th>
                                <th>Numero de certificado</th>
                                <th>Marca</th>
                                <th>Numero de lote</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((dato) => (
                                <tr key={dato.id}>
                                    <td>{dato.id}</td>
                                    <td>{dato.contenidoalcoholico}</td>
                                    <td>{dato.numeroanalisis}</td>
                                    <td>{dato.numerocertificado}</td>
                                    <td>{dato.marca}</td>
                                    <td>{dato.numerolote}</td>
                                    {/* <td>{dato.numerobotellas}</td> */}
                                    {/* <td>{dato.numerocajas}</td> */}
                                    <td>
                                        <Button
                                            color="primary"
                                            onClick={() => this.mostrarModalActualizar(dato)}
                                        >
                                            Editar
                                        </Button>{" "}
                                        <Button color="danger" onClick={() => this.eliminar(dato)}>Eliminar</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Container>

                {/* <Modal isOpen={this.state.modalActualizar}>
                    <ModalHeader>
                        <div><h3>Editar Registro</h3></div>
                    </ModalHeader>

                    <ModalBody>
                        <FormGroup>
                            <label>
                                Id:
                            </label>

                            <input
                                className="form-control"
                                readOnly
                                type="text"
                                value={this.state.form.id}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Personaje:
                            </label>
                            <input
                                className="form-control"
                                name="personaje"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.form.personaje}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Anime:
                            </label>
                            <input
                                className="form-control"
                                name="anime"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.form.anime}
                            />
                        </FormGroup>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => this.editar(this.state.form)}
                        >
                            Editar
                        </Button>
                        <Button
                            color="danger"
                            onClick={() => this.cerrarModalActualizar()}
                        >
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal> */}



                {/* <Modal isOpen={this.state.modalInsertar}>
                    <ModalHeader>
                        <div><h3>Insertar Personaje</h3></div>
                    </ModalHeader>

                    <ModalBody>
                        <FormGroup>
                            <label>
                                Id:
                            </label>

                            <input
                                className="form-control"
                                readOnly
                                type="text"
                                value={this.state.data.length + 1}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Personaje:
                            </label>
                            <input
                                className="form-control"
                                name="personaje"
                                type="text"
                                onChange={this.handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Anime:
                            </label>
                            <input
                                className="form-control"
                                name="anime"
                                type="text"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => this.insertar()}
                        >
                            Insertar
                        </Button>
                        <Button
                            className="btn btn-danger"
                            onClick={() => this.cerrarModalInsertar()}
                        >
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal> */}
            </>
        );
    }
}
export default Productos;